<template>
  <div class="about bg-color-dark pt-4 pb-4">
    <vue-headful :title="doctitle" />
    <b-container class="pb-5">
      <b-row>
        <b-col xl="1"></b-col>
        <b-col>
          <h1 class="mt-5 text-color-light big-headline">Program Committee</h1>

          <p class="p-margin-bottom">
            Øredev is over 100 technical sessions, ~100 top-notch speakers from
            all over, 6 keynotes revolving around a theme that changes every
            year, and some 1,300 visitors during 3 days at the beginning of
            November.
          </p>

          <p class="">
            All this is coordinated by 2 people and the program largely composed
            by our committee. We are immensely thankful to them for making
            Øredev what it is.
          </p>

          <h2 class="headline-margin-top">Members</h2>

          <p class="p-margin-bottom">
            These are the people that have poured days of their headspace into
            crafting the program for this year's Øredev. After planning the
            tracks, they spent hours getting the right person to take the stage
            and speak on the topic.
          </p>
          <p class="p-margin-bottom">
            Without them, there would be no program or its quality would be
            vastly inferior. Without them, there would be no Øredev. Boundless
            thanks for being some of the most driven, competent, and fun people
            we know.
          </p>

          <div class="team">
            <div
              class="member"
              v-for="member in committee"
              v-bind:key="member.name"
            >
              <img class="member-image" :src="member.image" />
              <div class="member-description">
                <h2 class="text-center">{{ member.name }}</h2>
                <h3>{{ member.track }}</h3>
                <p class="p-margin-bottom">{{ member.description }}</p>
              </div>
            </div>
          </div>
          <h2 class="mt-4">
            Feel like shaping one of the largest conferences in The Nordics?
          </h2>

          <p class="p-margin-bottom">
            We are on the lookout for new committee members. Don't hesitate a
            second to get in touch at
            <a href="mailto:info@oredev.org">info@oredev.org</a> if you're
            interested.
          </p>

          <p class="p-margin-bottom">
            You would be responsible for building a strong, coherent, balanced
            track or two, such as data, web, or people. Typically, two to three
            people are in charge of each track since it’s extremely important to
            have someone to bounce ideas off, get second opinions, and inspire
            one another.
          </p>

          <p class="p-margin-bottom">
            Building a track comprises two major tasks:
          </p>

          <ul>
            <li>
              Invite speakers of your choice: Get outstanding speakers you
              believe everyone should see live to Øredev. Sky is the limit,
              maybe they have developed or contributed your favourite tools,
              frameworks, or projects, or have done some of your favourite
              talks.
            </li>
            <li>
              Find excellence in call for papers (CFP): We get over 300
              applications through the CFP (open March 1– March 31). This task,
              therefore, consists in sifting through the applications pertaining
              to your track, looking for (mostly) emerging speakers. This way,
              we get fresh perspectives and support new talent.
            </li>
          </ul>

          <h2 class="headline-margin-top">Commitment</h2>

          <p class="p-margin-bottom">
            ~90% of the program needs to be finished by June 1, so the bulk of
            the work happens between February and May. In these months,
            calculate with some 12 hours a month on average to find & invite
            speakers and sift through CFP.
          </p>

          <p class="p-margin-bottom">
            Between Feb and May, we have one physical meeting a month in Malmö.
            Here, most of the committee meets, we discuss the progress,
            priorities, and needs. Then, it's typically some track discussions
            and once we're done, we head out for a good dinner, drinks, and more
            discussions — both tech and non-tech related. In other words, it's
            ~4 hours starting around 4pm.
          </p>

          <p class="p-margin-bottom">
            It is naturally possible to meet separately or take such discussions
            remotely. It’s simply that, at least sometimes, it's awesome to meet
            in person 😉
          </p>

          <h2 class="headline-margin-top">Perks &amp; Fun</h2>

          <p class="p-margin-bottom">
            Inviting speakers and shaping Øredev should feel like one of the
            perks.
          </p>

          <p class="p-margin-bottom">
            Naturally, you get a free ticket to the entire conference. You’re
            also an integral part of the extracurriculars — dip in the sea &
            dinner at Kallbadhuset and dinner at Malmö Rådhuset just before the
            conference. You are also more than welcome to tour Malmö with them.
          </p>
          <p class="p-margin-bottom">
            At the end of summer, we do a funfixer together to celebrate. Last
            but not least, the hangouts after the committee meetings tend to be
            pretty sweet.
          </p>

          <p class="p-margin-bottom">
            If this sounds tempting, we would love to hear from you at
            <a href="mailto:info@oredev.org">info@oredev.org</a>.
          </p>
        </b-col>
        <b-col xl="1"></b-col>
      </b-row>
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-1"
        src="https://res.cloudinary.com/oredev/image/upload/v1679424057/2023_web/shapes%20lp/white-shape-1.png"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-2"
        src="https://res.cloudinary.com/oredev/image/upload/v1683012353/2023_web/white-shape-2.png"
      />
      <img
        src="https://res.cloudinary.com/oredev/image/upload/v1679424058/2023_web/shapes%20lp/white-shape-5.png"
        class="d-none d-xl-block position-absolute"
        id="white-shape-3"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1680087567/2023_web/shapes%20info/white-shape-3.png"
        alt="rectangle"
      />

      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-7"
        src="https://res.cloudinary.com/oredev/image/upload/v1680090042/2023_web/shapes%20info/white-shape-5.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-8"
        src="https://res.cloudinary.com/oredev/image/upload/v1680089901/2023_web/shapes%20info/white-shape-7.png"
        alt="rectangle"
      />

      <img
        class="rectangle-long-1 position-absolute"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
      <img
        class="rectangle-long-2 d-none d-md-block position-absolute"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-2"
        src="https://res.cloudinary.com/oredev/image/upload/v1679666601/2023_web/shapes%20info/Blue-shape-1.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-3"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <!-- here -->

      <img
        class="rectangle-green-short position-absolute"
        id="green-5"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <img
        class="rectangle-orange position-absolute"
        id="orange-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-6"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
    </b-container>
  </div>
</template>

<script>
export default {
  name: "committee",
  data() {
    return {
      doctitle: "Program Committee - " + this.$store.state.conferencename,
      committee: [
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1683016259/2023_web/Adam_Odin___Web_1.png",
          name: "Adam Odin",
          track: `Web`,
        },
        {
          image: "/static/team/amelia.jpg",
          name: "Amelia Barklid",
          track: `Eagle Eye`,
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1683016341/2023_web/Anders_Marchsteiner___Architecture_1.png",
          name: "Anders Marchsteiner",
          track: `Architecture`,
        },

        {
          image: `https://res.cloudinary.com/oredev/image/upload/v1683016394/2023_web/Bala%CC%81zs_Suhajda___OFF_Track_1.png`,
          name: `Balázs Suhajda`,
          track: "OFF Track",
        },
        {
          image: `https://res.cloudinary.com/oredev/image/upload/v1650390964/2022_web/profile_picture_bengt_sjo%CC%88din_-01.jpg`,
          name: `Bengt Sjödin`,
          track: ".NET",
        },
        {
          image: `https://res.cloudinary.com/oredev/image/upload/v1683016491/2023_web/Filip_A%CC%8Ahfelt___Web_1.png`,
          name: `Filip Åhfelt`,
          track: "Web",
        },
        {
          image: `https://res.cloudinary.com/oredev/image/upload/g_face,r_max,c_thumb,w_320,h_320/v1659465789/2022_web/henrik.jpg`,
          name: `Henrik Reich`,
          track: `Data`,
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/g_face,r_max,c_thumb,w_320,h_320/v1650391731/2022_web/HugoHjerte%CC%81n_2_compressed.jpg",
          name: "Hugo Hjertén",
          track: `Data`,
        },

        {
          image: `/static/committee/jakob.jpg`,
          name: `Jakob Wolman`,
          track: `People & Teams`,
        },
        {
          image: `https://res.cloudinary.com/oredev/image/upload/g_face,r_max,c_thumb,w_320,h_320/v1650390886/2022_web/Jens_Bogarve1.jpg`,
          name: `Jens Bogarve`,
          track: `Security`,
        },
        {
          image: `https://res.cloudinary.com/oredev/image/upload/g_face,r_max,c_thumb,w_320,h_320/v1650390883/2022_web/Jonas_Tyrone_Flodqvist_-_20171020_133943_6363.jpg`,
          name: `Jonas Flodqvist`,
          track: `Cloud & DevOps`,
        },
        {
          image: `https://res.cloudinary.com/oredev/image/upload/v1683542543/2023_web/Emy_kvadrat_1.png`,
          name: "Emy W. Kristoffersson",
          track: `Eagle eye`,
        },

        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1681908849/2023_web/maisa_1.png",
          name: "Maisa Dabus",
          track: `Øredev theme, Keynotes & workshops`,
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1683016821/2023_web/Marium_Zulfiqar__Quality_Test_1.png",
          name: "Marium Zulfiqar",
          track: `Quality & Test`,
        },
        {
          image: `https://res.cloudinary.com/oredev/image/upload/g_face,r_max,c_thumb,w_320,h_320/v1650540526/2022_web/Dokument1.png`,
          name: `Martin Rosén-Lidholm`,
          track: `People & Teams`,
        },
        {
          image: `/static/committee/maryam.jpg`,
          name: `Maryam Sarrafkia`,
          track: `.NET`,
        },
        {
          image: `https://res.cloudinary.com/oredev/image/upload/v1683016932/2023_web/Niklas_Hansson___Data_1.png`,
          name: `Niklas Hansson`,
          track: `Data`,
        },

        {
          image: `https://res.cloudinary.com/oredev/image/upload/g_face,r_max,c_thumb,w_320,h_320/v1659465790/2022_web/paleie.jpg`,
          name: `Pål Eie`,
          track: `Architecture, Cloud & DevOps`,
        },

        {
          image: `https://res.cloudinary.com/oredev/image/upload/g_face,r_max,c_thumb,w_320,h_320/v1650540709/2022_web/Dokument2.png`,
          name: `Sebastian Daschner `,
          track: `JVM`,
        },
        {
          image: `https://res.cloudinary.com/oredev/image/upload/v1683016984/2023_web/Sigge_Birgisson___Quality_Test_1.png`,
          name: `Sigurdur Birgisson`,
          track: `Quality & Test`,
        },
        {
          image: `https://res.cloudinary.com/oredev/image/upload/v1683017034/2023_web/Svante_Richter___Web_1.png`,
          name: `Svante Richter`,
          track: `Web`,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";
p,
h2,
li {
  color: $text-color-light;
}

h1 {
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 38px;
}
h2,
h3,
h4 {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

h2 {
  font-family: Verdana;
  font-size: 20px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
}
.team {
  display: grid;
  grid-template-columns: 30% 30% 30%;
  grid-column-gap: 5%;
  margin: 4rem 0 0;
  text-align: center;
}
.member {
  height: 400px;
  color: $text-color-light;
}
.member img {
  border-radius: 200px;
  height: auto;
  max-width: 100%;
  margin-bottom: 1rem;
  position: relative;
  z-index: 99;
}
.member h2 {
  font-size: 1.4rem !important;
  margin-bottom: 0;
}

h3 {
  font-size: 1.4rem;
}
.headline {
  padding-top: 30px;
  color: $text-color-light;
}

.member h3 {
  font-size: 1rem !important;
  margin-bottom: 1rem;
}

@media screen and (max-width: 991px) {
  .member {
    height: 240px;
  }
  .member img {
    max-width: 150px;
  }
}

@media screen and (max-width: 767px) {
  .team {
    grid-template-columns: 40% 40%;
    justify-content: center;

    grid-column-gap: 5%;
    margin: 4rem 0 0;
  }
  .member {
    height: 260px;
  }
  .member h2 {
    font-size: 0.9rem !important;
  }
  .member h3 {
    font-size: 0.8rem !important;
  }
  .member img {
    max-width: 150px;
  }
}

// @media screen and (max-width: 420px) {
//   // .team {
//   //   display: flex;
//   //   flex-direction: column;
//   // }
//   .member {
//     height: auto;
//     margin-bottom: 1rem;
//   }
//   .member h2 {
//     font-size: 1.3rem !important;
//   }
//   .member h3 {
//     font-size: 1.1rem !important;
//   }
//   .member img {
//     max-width: 300px;
//   }
// }

.rectangle-long-1 {
  width: 100%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  bottom: -196%;
  left: 0;
}
.rectangle-long-2 {
  width: 50%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  top: 140%;
  right: 0;
}
.rectangle-green-short,
.rectangle-orange {
  mix-blend-mode: color !important;
}
#green-2 {
  bottom: 50%;
  right: 0;
  z-index: 0;
  height: 16px;
  width: 51%;
}
#green-3 {
  bottom: 29%;
  left: 0;
  max-width: 80%;
  z-index: 0;
}
#green-4 {
  bottom: 17.5%;
  max-width: 58%;
  z-index: 1;
  right: 0;
}

#green-5 {
  bottom: -80%;
  left: 0;
  max-width: 80%;
  z-index: 0;
}
#green-6 {
  bottom: -130%;
  max-width: 58%;
  z-index: 1;
  right: 0;
}
#orange-3 {
  bottom: -50%;
  right: 0;
  z-index: 0;
  height: 16px;
  width: 51%;
}
#orange-4 {
  bottom: -110%;
  left: 0;
  width: 60%;
  height: 16px;
  z-index: 0;
}
#white-shape-1 {
  right: 30px;
  bottom: 75%;
}
#white-shape-2 {
  right: 35px;
  bottom: 71%;
}
#white-shape-2-mobile {
  right: 35px;
  bottom: 64%;
}
#white-shape-3 {
  right: 0;
  bottom: 37%;
  width: 16%;
}
#white-shape-4 {
  left: 3%;
  bottom: 37%;
}
#white-shape-5 {
  left: 3%;
  bottom: 13%;
}
#white-shape-6 {
  right: 3%;
  bottom: -22%;
}
#white-shape-7 {
  left: 3%;
  bottom: 10%;
}
#white-shape-8 {
  right: 3%;
  bottom: 13%;
}
</style>






// WEBPACK FOOTER //
// src/components/Committee.vue